import MaterialTable, { MTableToolbar } from 'material-table';
import React, { Component } from 'react';
import { getBaseUrlFromConfig } from '../utils/url_helpers';
import { Icon } from '@avalara/skylab-react';
import { get } from 'lodash';
var config = require('../config');

const salesforceBaseURL = getBaseUrlFromConfig(config.salesforce);

export default class ObligationIPS extends Component {
  transformObligation = (obligations: any) => {
    let result: any[] = [];
    for (const obligation of obligations) {
      const { entitlements, ...rest } = obligation;
      let updatedEntitlements;
      if (entitlements.length > 0) {
        updatedEntitlements = entitlements.map((ent: any) => {
          return { ...rest, entitlement: ent };
        });
      } else {
        updatedEntitlements = [{ ...rest, entitlement: [] }];
      }

      result = [...result, ...updatedEntitlements];
    }
    return result;
  };

  expandAllHandler = (tableRef: any, length: number) => {
    for (let i = 0; i < length; i++) {
      if (!tableRef.current?.state?.renderData[i]?.tableData?.showDetailPanel) {
        tableRef.current.onToggleDetailPanel(
          [i],
          tableRef.current.props.detailPanel
        );
      }
    }
  };

  collapseAllHandler = (tableRef: any, length: number) => {
    for (let i = 0; i < length; i++) {
      if (tableRef.current?.state?.renderData[i]?.tableData?.showDetailPanel) {
        tableRef.current.onToggleDetailPanel(
          [i],
          tableRef.current.props.detailPanel
        );
      }
    }
  };

  getFormattedEntitlements = (entitlement: any) => {
    let formattedEntitlements = '';
    formattedEntitlements += get(entitlement, 'deliverySystem', '-');
    if (entitlement.service)
      formattedEntitlements += `(${entitlement.service
        .map((e: any) => e.name)
        .join()})`;
    return formattedEntitlements;
  };

  render() {
    const obligationSummaries = this.transformObligation(
      (this.props as any).obligationSummaries
    );

    const data = obligationSummaries.map((o: any) => {
      return {
        access: o.accessStartDate,
        connectorName: o.connectorName,
        connectorId: o.connectorId,
        chargeType: o.chargeType,
        chargeModel: o.chargeModel,
        catalogItemName: o.catalogItemName,
        deliverySystem: get(o, 'entitlement.deliverySystem', '-'),
        entitlement: this.getFormattedEntitlements(o.entitlement),
        id: o.id,
        initialTerm: o.initialTerm,
        isAccessPermitted: o.isAccessPermitted,
        name: o.name,
        cpqId: o.cpqId,
        productFamilyName: o.productFamilyName,
        quantity: o.quantity,
        obligationSource: o.obligationSource,
        renewalTerm: o.renewalTerm,
        term: ` ${o.termStartDate} - ${o.termEndDate} `,
        termEnd: o.termEndDate,
        termStart: o.termStartDate,
        tier: `${o.tierFrom || 0} - ${o.tierTo || 'infinity'}`,
        type: o.type
      };
    });
    const tableRef: any = React.createRef();
    return (
      <MaterialTable
        tableRef={tableRef}
        title="IPS Obligations"
        columns={[
          { title: 'Delivery System', field: 'deliverySystem' },
          { title: 'ACCESS FROM', field: 'access' },
          { title: 'TERM', field: 'term' },
          { title: 'NAME', field: 'name' }
        ]}
        data={data}
        options={{
          grouping: true
        }}
        components={{
          Toolbar: props => (
            <div>
              <MTableToolbar {...props} />
              {!tableRef?.current?.dataManager?.grouped && (
                <div
                  style={{ padding: '10px 10px', backgroundColor: '#6F6F6F' }}
                >
                  <button
                    className="icon-trailing"
                    onClick={() => {
                      this.expandAllHandler(tableRef, data.length);
                    }}
                  >
                    Expand All <Icon name="arrow-down" />
                  </button>
                  <button
                    className="icon-trailing"
                    onClick={() => {
                      this.collapseAllHandler(tableRef, data.length);
                    }}
                  >
                    Collapse All <Icon name="arrow-right" />
                  </button>
                </div>
              )}
            </div>
          )
        }}
        detailPanel={rowData => (
          <div>
            <ul style={{ padding: '10px' }}>
              <li>
                <b>Obligation Id: </b>
                {(rowData as any).id}
              </li>
              <li>
                <b>Catalog Item Name: </b>
                {(rowData as any).catalogItemName}
              </li>
              <li>
                <b>Charge Type: </b>
                {(rowData as any).chargeType}
              </li>
              <li>
                <b>Charge Model: </b>
                {(rowData as any).chargeModel}
              </li>
              <li>
                <b>Entitlement : </b>
                {(rowData as any).entitlement}
              </li>
              <li>
                <b>Access Permitted : </b>
                {(rowData as any).isAccessPermitted}
              </li>
              <li>
                <b>CPQ Id: </b>
                {(rowData as any).cpqId}
              </li>
              <li>
                <b>Product Family Name: </b>
                {(rowData as any).productFamilyName}
              </li>
              <li>
                <b>Obligation Source: </b>
                {(rowData as any).obligationSource}{' '}
              </li>
              <li>
                <b>Type: </b>
                {(rowData as any).type}
              </li>
              <li>
                <b>Tier: </b>
                {(rowData as any).tier}
              </li>
              <li>
                <b>Connector: </b>
                <a
                  href={`${salesforceBaseURL}/${(rowData as any).connectorId}`}
                >
                  {(rowData as any).connectorName}{' '}
                  {(rowData as any).connectorId}
                </a>
              </li>
            </ul>
          </div>
        )}
      />
    );
  }
}
